module.exports = __webpack_public_path__ + "img/gy1.262c5d5b.png";